import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const SelectFilter = styled.div.attrs(() => ({
    className: 'form-group !mb-2 lg:!mb-0 lg:!mr-2',
}))`
    min-width: 200px;
    width: 100%;

    ${breakpoint('laptop')`
        width: auto;
    `};

    .list__control {
        border-radius: 0px;
        min-height: 36px;
    }

    .list__dropdown-indicator {
        padding: 6px 8px;
    }

    .list__menu {
        z-index: 100;
    }
`
